import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import zh from './locales/zh.json'
import ru from './locales/ru.json'
import th from './locales/th.json'

const SUPPORTED_LOCALES = ['zh', 'en', 'ru', 'th'] as const
type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

function normalizeLocale(input: unknown): SupportedLocale | null {
  if (typeof input !== 'string') return null
  const val = input.trim()
  return (SUPPORTED_LOCALES as readonly string[]).includes(val) ? (val as SupportedLocale) : null
}

// Check for global variable injected by server (optional)
const serverLocale =
  typeof window !== 'undefined'
    ? normalizeLocale((window as Window & { INITIAL_LOCALE?: unknown }).INITIAL_LOCALE)
    : null

let storedLocale: SupportedLocale | null = null
if (typeof window !== 'undefined') {
  try {
    storedLocale = normalizeLocale(window.localStorage?.getItem('user_locale'))
  } catch {
    storedLocale = null
  }
}

const i18n = createI18n({
    legacy: false, // For Vue 3 Composition API
    locale: storedLocale || serverLocale || 'zh',
    fallbackLocale: 'en',
    messages: {
        en,
        zh,
        ru,
        th
    }
})

export default i18n
